// Client layer (TS-2.5.03). Renders a project's milestone series (already sequenced by
// ProjectProgressEngine, V-15) as a horizontally scrolling, dated, status-coloured list - the
// roadmap.web OutputLayoutProfile.MilestoneDisplay is "ScrollingTimeline" (uncapped), unlike the
// deck's "CappedList" (decomposition.md section 8.7 point 7), so this component never truncates.
import type { CSSProperties } from "react";
import { resolveColor } from "./lib/colorTokens";
import type { MilestoneView } from "../../api/generated/contracts";
import { strings } from "../../strings";

export interface MilestoneTimelineProps {
  readonly milestones: readonly MilestoneView[];
}

export function MilestoneTimeline({ milestones }: MilestoneTimelineProps) {
  const ordered = [...milestones].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <ol className="eg-milestone-timeline" aria-label={strings.roadmap.aria.milestones}>
      {ordered.map((milestone) => (
        <li key={milestone.key} className="eg-milestone-timeline__item">
          {/* Custom property -> roadmap.css derives an ink-mixed rim from the dot's own colour,
              so the palest completion colour (#D5D2C7) still reads on the white card (D-247). */}
          <span
            className="eg-milestone-timeline__dot"
            aria-hidden="true"
            style={{ "--eg-swatch-color": resolveColor(milestone.completionColorHex) } as CSSProperties}
          />
          <span className="eg-milestone-timeline__label">{milestone.label}</span>
          <span className="eg-milestone-timeline__date">{milestone.dateLabel}</span>
          <span className="eg-milestone-timeline__status">{milestone.completionLabel}</span>
        </li>
      ))}
    </ol>
  );
}
